const MASK = '[redigido]';

const SENSITIVE_KEY_PATTERNS = [
  'authorization',
  'password',
  'secret',
  'token',
  'cpf',
  'cnpj',
  'phone',
  'telefone',
  'whatsapp',
  'email',
  'document',
  'matricula',
  'matrícula',
  'pix',
  'bank',
  'account',
];

const isObject = value =>
  value !== null && typeof value === 'object' && !Array.isArray(value);

const shouldRedactKey = key => {
  if (key === null || key === undefined) return false;
  const normalizedKey = String(key).toLowerCase();
  return SENSITIVE_KEY_PATTERNS.some(pattern =>
    normalizedKey.includes(pattern)
  );
};

const redactString = value =>
  String(value)
    .replace(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi, '[email-redigido]')
    .replace(/\b\d{3}\.?\d{3}\.?\d{3}-?\d{2}\b/g, '[cpf-redigido]')
    .replace(/\b\d{2}\.?\d{3}\.?\d{3}\/?\d{4}-?\d{2}\b/g, '[cnpj-redigido]')
    .replace(
      /\b(?:\+?55\s*)?(?:\(?\d{2}\)?\s*)?9?\d{4}[-\s]?\d{4}\b/g,
      '[telefone-redigido]'
    );

export const redactLaisPayload = (value, key = null, seen = new WeakSet()) => {
  if (shouldRedactKey(key)) return MASK;
  if (typeof value === 'string') return redactString(value);
  if (Array.isArray(value)) {
    if (seen.has(value)) return '[referencia-circular]';
    seen.add(value);
    return value.map(item => redactLaisPayload(item, null, seen));
  }
  if (isObject(value)) {
    if (seen.has(value)) return '[referencia-circular]';
    seen.add(value);
    return Object.keys(value).reduce((acc, childKey) => {
      acc[childKey] = redactLaisPayload(value[childKey], childKey, seen);
      return acc;
    }, {});
  }
  return value;
};
